/* 95487d36fb0f9c116e2d6ade5280a00a7eb08c5f
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SelectedPaymentMethodQueryVariables = Types.Exact<{
  cartId: Types.Scalars['String']['input'];
}>;


export type SelectedPaymentMethodQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', id: string, selected_payment_method?: { __typename?: 'SelectedPaymentMethod', code: string, title: string } | null } | null };

export type SelectedShippingMethodQueryVariables = Types.Exact<{
  cartId: Types.Scalars['String']['input'];
}>;


export type SelectedShippingMethodQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', id: string, shipping_addresses: Array<{ __typename?: 'ShippingCartAddress', selected_shipping_method?: { __typename?: 'SelectedShippingMethod', carrier_code: string, carrier_title: string, method_code: string, method_title: string, amount: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null } | null> } | null };

export type AvailableShippingMethodsQueryVariables = Types.Exact<{
  cartId: Types.Scalars['String']['input'];
}>;


export type AvailableShippingMethodsQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', id: string, shipping_addresses: Array<{ __typename?: 'ShippingCartAddress', available_shipping_methods?: Array<{ __typename?: 'AvailableShippingMethod', available: boolean, carrier_code: string, method_code?: string | null, method_title?: string | null, amount: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null> | null, selected_shipping_method?: { __typename?: 'SelectedShippingMethod', method_title: string, method_code: string, carrier_code: string, carrier_title: string, amount: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null } | null> } | null };

export type AvailablePaymentMethodsQueryVariables = Types.Exact<{
  cartId: Types.Scalars['String']['input'];
}>;


export type AvailablePaymentMethodsQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', id: string, available_payment_methods?: Array<{ __typename?: 'AvailablePaymentMethod', code: string, title: string } | null> | null, selected_payment_method?: { __typename?: 'SelectedPaymentMethod', code: string, title: string } | null } | null };

export type CartItemsQueryVariables = Types.Exact<{
  cartId: Types.Scalars['String']['input'];
}>;


export type CartItemsQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', id: string, items?: Array<{ __typename?: 'BundleCartItem', quantity: number, id: string, product: { __typename: 'BundleProduct', name?: string | null, has_gift?: boolean | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null } | { __typename: 'ConfigurableProduct', name?: string | null, has_gift?: boolean | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null } | { __typename: 'DownloadableProduct', name?: string | null, has_gift?: boolean | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null } | { __typename: 'GroupedProduct', name?: string | null, has_gift?: boolean | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null } | { __typename: 'SimpleProduct', name?: string | null, has_gift?: boolean | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null } | { __typename: 'VirtualProduct', name?: string | null, has_gift?: boolean | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null }, prices?: { __typename?: 'CartItemPrices', discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', value?: number | null, currency?: Types.CurrencyEnum | null } } | null> | null, price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, row_total: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: Types.CurrencyEnum | null }, total_item_discount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null } | { __typename?: 'ConfigurableCartItem', quantity: number, id: string, product: { __typename?: 'BundleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: Types.ProductStockStatus | null, brand?: number | null, has_gift?: boolean | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: Types.ProductStockStatus | null, brand?: number | null, has_gift?: boolean | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: Types.ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'DownloadableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: Types.ProductStockStatus | null, brand?: number | null, has_gift?: boolean | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'GroupedProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: Types.ProductStockStatus | null, brand?: number | null, has_gift?: boolean | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: Types.ProductStockStatus | null, brand?: number | null, has_gift?: boolean | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'VirtualProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: Types.ProductStockStatus | null, brand?: number | null, has_gift?: boolean | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null }, configurable_options: Array<{ __typename?: 'SelectedConfigurableOption', id: number, option_label: string, value_id: number, value_label: string } | null>, prices?: { __typename?: 'CartItemPrices', discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', value?: number | null, currency?: Types.CurrencyEnum | null } } | null> | null, price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, row_total: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, row_total_including_tax: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, total_item_discount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null } | { __typename?: 'DownloadableCartItem', id: string } | { __typename?: 'SimpleCartItem', quantity: number, id: string, product: { __typename?: 'BundleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: Types.ProductStockStatus | null, brand?: number | null, has_gift?: boolean | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: Types.ProductStockStatus | null, brand?: number | null, has_gift?: boolean | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null } | { __typename?: 'DownloadableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: Types.ProductStockStatus | null, brand?: number | null, has_gift?: boolean | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null } | { __typename?: 'GroupedProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: Types.ProductStockStatus | null, brand?: number | null, has_gift?: boolean | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: Types.ProductStockStatus | null, brand?: number | null, has_gift?: boolean | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null } | { __typename?: 'VirtualProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: Types.ProductStockStatus | null, brand?: number | null, has_gift?: boolean | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, categories?: Array<{ __typename?: 'CategoryTree', name?: string | null, level?: number | null, priority?: number | null } | null> | null }, prices?: { __typename?: 'CartItemPrices', discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', value?: number | null, currency?: Types.CurrencyEnum | null } } | null> | null, price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, row_total: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: Types.CurrencyEnum | null }, total_item_discount?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null } | { __typename?: 'VirtualCartItem', id: string } | null> | null } | null };

export type CartTotalQueryVariables = Types.Exact<{
  cartId: Types.Scalars['String']['input'];
}>;


export type CartTotalQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', id: string, prices?: { __typename?: 'CartPrices', applied_taxes?: Array<{ __typename?: 'CartTaxItem', amount: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null> | null, discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null> | null, grand_total?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null, subtotal_excluding_tax?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null, subtotal_including_tax?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null, subtotal_with_discount_excluding_tax?: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } | null } | null } | null };

export type CartShippingAddressQueryVariables = Types.Exact<{
  cartId: Types.Scalars['String']['input'];
}>;


export type CartShippingAddressQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', id: string, email?: string | null, shipping_addresses: Array<{ __typename?: 'ShippingCartAddress', lastname: string, postcode?: string | null, firstname: string, customer_notes?: string | null, city: string, district?: string | null, district_id?: number | null, ward?: string | null, ward_id?: number | null, street: Array<string | null>, telephone: string, country: { __typename?: 'CartAddressCountry', code: string, label: string }, region?: { __typename?: 'CartAddressRegion', code: string, label: string } | null } | null> } | null };

export type CustomerCartQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CustomerCartQuery = { __typename?: 'Query', customerCart: { __typename?: 'Cart', id: string } };

export type SetPaymentMethodOnCartMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.SetPaymentMethodOnCartInput>;
}>;


export type SetPaymentMethodOnCartMutation = { __typename?: 'Mutation', setPaymentMethodOnCart?: { __typename?: 'SetPaymentMethodOnCartOutput', cart: { __typename?: 'Cart', id: string, selected_payment_method?: { __typename?: 'SelectedPaymentMethod', code: string, purchase_order_number?: string | null, title: string } | null } } | null };

export type SetShippingMethodsOnCartMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.SetShippingMethodsOnCartInput>;
}>;


export type SetShippingMethodsOnCartMutation = { __typename?: 'Mutation', setShippingMethodsOnCart?: { __typename?: 'SetShippingMethodsOnCartOutput', cart: { __typename?: 'Cart', id: string, shipping_addresses: Array<{ __typename?: 'ShippingCartAddress', selected_shipping_method?: { __typename?: 'SelectedShippingMethod', method_title: string, method_code: string, carrier_code: string, carrier_title: string, amount: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null } | null> } } | null };

export type SetGuestEmailOnCartMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.SetGuestEmailOnCartInput>;
}>;


export type SetGuestEmailOnCartMutation = { __typename?: 'Mutation', setGuestEmailOnCart?: { __typename?: 'SetGuestEmailOnCartOutput', cart: { __typename?: 'Cart', id: string, email?: string | null } } | null };

export type PlaceOrderMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.PlaceOrderInput>;
}>;


export type PlaceOrderMutation = { __typename?: 'Mutation', placeOrder?: { __typename?: 'PlaceOrderOutput', order: { __typename?: 'Order', order_id?: string | null, order_number: string } } | null };

export type SetShippingAddressesOnCartMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.SetShippingAddressesOnCartInput>;
}>;


export type SetShippingAddressesOnCartMutation = { __typename?: 'Mutation', setShippingAddressesOnCart?: { __typename?: 'SetShippingAddressesOnCartOutput', cart: { __typename?: 'Cart', id: string } } | null };

export type SetBillingAddressesOnCartMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.SetBillingAddressOnCartInput>;
}>;


export type SetBillingAddressesOnCartMutation = { __typename?: 'Mutation', setBillingAddressOnCart?: { __typename?: 'SetBillingAddressOnCartOutput', cart: { __typename?: 'Cart', id: string } } | null };

export type AvailableCouponsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AvailableCouponsQuery = { __typename?: 'Query', availableCoupons?: Array<{ __typename?: 'SalesRule', code?: string | null, description?: string | null, from_date?: string | null, is_active?: boolean | null, name?: string | null, to_date?: string | null } | null> | null };

export type GetDiscountKicoinsQueryVariables = Types.Exact<{
  cartId: Types.Scalars['String']['input'];
}>;


export type GetDiscountKicoinsQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', id: string, discount_kicoins?: { __typename?: 'DiscountKicoins', title?: string | null, value?: number | null } | null } | null };

export type ApplyKicoinsToCartMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.ApplyKicoinsInput>;
}>;


export type ApplyKicoinsToCartMutation = { __typename?: 'Mutation', applyKicoins?: { __typename?: 'ApplyKicoinsOutput', cart: { __typename?: 'Cart', id: string } } | null };

export type RemoveKicoinsFromCartMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.RemoveKicoinsInput>;
}>;


export type RemoveKicoinsFromCartMutation = { __typename?: 'Mutation', removeKicoins?: { __typename?: 'RemoveKicoinsOutput', cart: { __typename?: 'Cart', id: string, discount_kicoins?: { __typename?: 'DiscountKicoins', title?: string | null, value?: number | null } | null } } | null };

export type CustomerKicoinQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CustomerKicoinQuery = { __typename?: 'Query', customerKicoin?: { __typename?: 'CustomerKicoin', available?: number | null, balance?: number | null } | null };

export type ApplyCouponToCartMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.ApplyCouponToCartInput>;
}>;


export type ApplyCouponToCartMutation = { __typename?: 'Mutation', applyCouponToCart?: { __typename?: 'ApplyCouponToCartOutput', cart: { __typename?: 'Cart', id: string, applied_coupons?: Array<{ __typename?: 'AppliedCoupon', code: string } | null> | null } } | null };

export type RemoveCouponFromCartMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.RemoveCouponFromCartInput>;
}>;


export type RemoveCouponFromCartMutation = { __typename?: 'Mutation', removeCouponFromCart?: { __typename?: 'RemoveCouponFromCartOutput', cart?: { __typename?: 'Cart', id: string, applied_coupons?: Array<{ __typename?: 'AppliedCoupon', code: string } | null> | null } | null } | null };

export type GetAppliedCouponsQueryVariables = Types.Exact<{
  cartId: Types.Scalars['String']['input'];
}>;


export type GetAppliedCouponsQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', applied_coupons?: Array<{ __typename?: 'AppliedCoupon', code: string } | null> | null } | null };

export type CartItemsStatusQueryVariables = Types.Exact<{
  cartId: Types.Scalars['String']['input'];
}>;


export type CartItemsStatusQuery = { __typename?: 'Query', cartItemsStatus: Array<{ __typename?: 'ItemStatus', sku: string, stock_status: { __typename?: 'StockStatus', code: number, message: string, current_available: number } } | null> };


export const SelectedPaymentMethodDocument = gql`
    query SelectedPaymentMethod($cartId: String!) {
  cart(cart_id: $cartId) {
    id
    selected_payment_method {
      code
      title
    }
  }
}
    `;

/**
 * __useSelectedPaymentMethodQuery__
 *
 * To run a query within a React component, call `useSelectedPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedPaymentMethodQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useSelectedPaymentMethodQuery(baseOptions: Apollo.QueryHookOptions<SelectedPaymentMethodQuery, SelectedPaymentMethodQueryVariables> & ({ variables: SelectedPaymentMethodQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectedPaymentMethodQuery, SelectedPaymentMethodQueryVariables>(SelectedPaymentMethodDocument, options);
      }
export function useSelectedPaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectedPaymentMethodQuery, SelectedPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectedPaymentMethodQuery, SelectedPaymentMethodQueryVariables>(SelectedPaymentMethodDocument, options);
        }
export function useSelectedPaymentMethodSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SelectedPaymentMethodQuery, SelectedPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectedPaymentMethodQuery, SelectedPaymentMethodQueryVariables>(SelectedPaymentMethodDocument, options);
        }
export type SelectedPaymentMethodQueryHookResult = ReturnType<typeof useSelectedPaymentMethodQuery>;
export type SelectedPaymentMethodLazyQueryHookResult = ReturnType<typeof useSelectedPaymentMethodLazyQuery>;
export type SelectedPaymentMethodSuspenseQueryHookResult = ReturnType<typeof useSelectedPaymentMethodSuspenseQuery>;
export type SelectedPaymentMethodQueryResult = Apollo.QueryResult<SelectedPaymentMethodQuery, SelectedPaymentMethodQueryVariables>;
export const SelectedShippingMethodDocument = gql`
    query SelectedShippingMethod($cartId: String!) {
  cart(cart_id: $cartId) {
    id
    shipping_addresses {
      selected_shipping_method {
        amount {
          currency
          value
        }
        carrier_code
        carrier_title
        method_code
        method_title
      }
    }
  }
}
    `;

/**
 * __useSelectedShippingMethodQuery__
 *
 * To run a query within a React component, call `useSelectedShippingMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedShippingMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedShippingMethodQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useSelectedShippingMethodQuery(baseOptions: Apollo.QueryHookOptions<SelectedShippingMethodQuery, SelectedShippingMethodQueryVariables> & ({ variables: SelectedShippingMethodQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectedShippingMethodQuery, SelectedShippingMethodQueryVariables>(SelectedShippingMethodDocument, options);
      }
export function useSelectedShippingMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectedShippingMethodQuery, SelectedShippingMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectedShippingMethodQuery, SelectedShippingMethodQueryVariables>(SelectedShippingMethodDocument, options);
        }
export function useSelectedShippingMethodSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SelectedShippingMethodQuery, SelectedShippingMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectedShippingMethodQuery, SelectedShippingMethodQueryVariables>(SelectedShippingMethodDocument, options);
        }
export type SelectedShippingMethodQueryHookResult = ReturnType<typeof useSelectedShippingMethodQuery>;
export type SelectedShippingMethodLazyQueryHookResult = ReturnType<typeof useSelectedShippingMethodLazyQuery>;
export type SelectedShippingMethodSuspenseQueryHookResult = ReturnType<typeof useSelectedShippingMethodSuspenseQuery>;
export type SelectedShippingMethodQueryResult = Apollo.QueryResult<SelectedShippingMethodQuery, SelectedShippingMethodQueryVariables>;
export const AvailableShippingMethodsDocument = gql`
    query AvailableShippingMethods($cartId: String!) {
  cart(cart_id: $cartId) {
    id
    shipping_addresses {
      available_shipping_methods {
        amount {
          currency
          value
        }
        available
        carrier_code
        method_code
        method_title
      }
      selected_shipping_method {
        amount {
          currency
          value
        }
        method_title
        method_code
        carrier_code
        carrier_title
      }
    }
  }
}
    `;

/**
 * __useAvailableShippingMethodsQuery__
 *
 * To run a query within a React component, call `useAvailableShippingMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableShippingMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableShippingMethodsQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useAvailableShippingMethodsQuery(baseOptions: Apollo.QueryHookOptions<AvailableShippingMethodsQuery, AvailableShippingMethodsQueryVariables> & ({ variables: AvailableShippingMethodsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableShippingMethodsQuery, AvailableShippingMethodsQueryVariables>(AvailableShippingMethodsDocument, options);
      }
export function useAvailableShippingMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableShippingMethodsQuery, AvailableShippingMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableShippingMethodsQuery, AvailableShippingMethodsQueryVariables>(AvailableShippingMethodsDocument, options);
        }
export function useAvailableShippingMethodsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailableShippingMethodsQuery, AvailableShippingMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableShippingMethodsQuery, AvailableShippingMethodsQueryVariables>(AvailableShippingMethodsDocument, options);
        }
export type AvailableShippingMethodsQueryHookResult = ReturnType<typeof useAvailableShippingMethodsQuery>;
export type AvailableShippingMethodsLazyQueryHookResult = ReturnType<typeof useAvailableShippingMethodsLazyQuery>;
export type AvailableShippingMethodsSuspenseQueryHookResult = ReturnType<typeof useAvailableShippingMethodsSuspenseQuery>;
export type AvailableShippingMethodsQueryResult = Apollo.QueryResult<AvailableShippingMethodsQuery, AvailableShippingMethodsQueryVariables>;
export const AvailablePaymentMethodsDocument = gql`
    query AvailablePaymentMethods($cartId: String!) {
  cart(cart_id: $cartId) {
    id
    available_payment_methods {
      code
      title
    }
    selected_payment_method {
      code
      title
    }
  }
}
    `;

/**
 * __useAvailablePaymentMethodsQuery__
 *
 * To run a query within a React component, call `useAvailablePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailablePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailablePaymentMethodsQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useAvailablePaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables> & ({ variables: AvailablePaymentMethodsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>(AvailablePaymentMethodsDocument, options);
      }
export function useAvailablePaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>(AvailablePaymentMethodsDocument, options);
        }
export function useAvailablePaymentMethodsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>(AvailablePaymentMethodsDocument, options);
        }
export type AvailablePaymentMethodsQueryHookResult = ReturnType<typeof useAvailablePaymentMethodsQuery>;
export type AvailablePaymentMethodsLazyQueryHookResult = ReturnType<typeof useAvailablePaymentMethodsLazyQuery>;
export type AvailablePaymentMethodsSuspenseQueryHookResult = ReturnType<typeof useAvailablePaymentMethodsSuspenseQuery>;
export type AvailablePaymentMethodsQueryResult = Apollo.QueryResult<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>;
export const CartItemsDocument = gql`
    query CartItems($cartId: String!) {
  cart(cart_id: $cartId) {
    id
    items {
      id
      ... on SimpleCartItem {
        quantity
        product {
          id
          sku
          name
          url_key
          url_suffix
          stock_status
          brand
          has_gift
          price_range {
            maximum_price {
              discount {
                amount_off
                percent_off
              }
              final_price {
                currency
                value
              }
              fixed_product_taxes {
                amount {
                  currency
                  value
                }
                label
              }
              regular_price {
                currency
                value
              }
            }
            minimum_price {
              discount {
                amount_off
                percent_off
              }
              final_price {
                currency
                value
              }
              fixed_product_taxes {
                amount {
                  currency
                  value
                }
                label
              }
              regular_price {
                currency
                value
              }
            }
          }
          thumbnail {
            disabled
            label
            position
            url
          }
          small_image {
            disabled
            label
            position
            url
          }
          categories {
            name
            level
            priority
          }
          special_from_date
          special_price
          special_to_date
        }
        prices {
          discounts {
            amount {
              value
              currency
            }
            label
          }
          price {
            currency
            value
          }
          row_total {
            currency
            value
          }
          row_total_including_tax {
            value
            currency
          }
          total_item_discount {
            currency
            value
          }
        }
      }
      ... on BundleCartItem {
        quantity
        product {
          __typename
          thumbnail {
            disabled
            label
            position
            url
          }
          name
          has_gift
          categories {
            name
            level
            priority
          }
        }
        prices {
          discounts {
            amount {
              value
              currency
            }
            label
          }
          price {
            currency
            value
          }
          row_total {
            currency
            value
          }
          row_total_including_tax {
            value
            currency
          }
          total_item_discount {
            currency
            value
          }
        }
      }
      ... on ConfigurableCartItem {
        quantity
        product {
          id
          sku
          name
          url_key
          url_suffix
          stock_status
          brand
          has_gift
          categories {
            name
            level
            priority
          }
          price_range {
            maximum_price {
              discount {
                amount_off
                percent_off
              }
              final_price {
                currency
                value
              }
              fixed_product_taxes {
                amount {
                  currency
                  value
                }
                label
              }
              regular_price {
                currency
                value
              }
            }
            minimum_price {
              discount {
                amount_off
                percent_off
              }
              final_price {
                currency
                value
              }
              fixed_product_taxes {
                amount {
                  currency
                  value
                }
                label
              }
              regular_price {
                currency
                value
              }
            }
          }
          thumbnail {
            disabled
            label
            position
            url
          }
          small_image {
            disabled
            label
            position
            url
          }
          special_from_date
          special_price
          special_to_date
          ... on ConfigurableProduct {
            configurable_options {
              attribute_code
              attribute_id
              product_id
              id
              label
              position
              use_default
              values {
                default_label
                label
                store_label
                use_default_value
                value_index
              }
            }
            variants {
              attributes {
                code
                label
                value_index
              }
              product {
                id
                sku
                name
                url_key
                url_suffix
                stock_status
                brand
                ratings_count
                ratings_summary
                thumbnail {
                  disabled
                  label
                  position
                  url
                }
                small_image {
                  disabled
                  label
                  position
                  url
                }
                price_range {
                  maximum_price {
                    discount {
                      amount_off
                      percent_off
                    }
                    final_price {
                      currency
                      value
                    }
                    fixed_product_taxes {
                      amount {
                        currency
                        value
                      }
                      label
                    }
                    regular_price {
                      currency
                      value
                    }
                  }
                  minimum_price {
                    discount {
                      amount_off
                      percent_off
                    }
                    final_price {
                      currency
                      value
                    }
                    fixed_product_taxes {
                      amount {
                        currency
                        value
                      }
                      label
                    }
                    regular_price {
                      currency
                      value
                    }
                  }
                }
              }
            }
          }
        }
        configurable_options {
          id
          option_label
          value_id
          value_label
        }
        prices {
          discounts {
            amount {
              value
              currency
            }
            label
          }
          price {
            currency
            value
          }
          row_total {
            currency
            value
          }
          row_total_including_tax {
            currency
            value
          }
          total_item_discount {
            currency
            value
          }
        }
        id
        quantity
      }
    }
  }
}
    `;

/**
 * __useCartItemsQuery__
 *
 * To run a query within a React component, call `useCartItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartItemsQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useCartItemsQuery(baseOptions: Apollo.QueryHookOptions<CartItemsQuery, CartItemsQueryVariables> & ({ variables: CartItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartItemsQuery, CartItemsQueryVariables>(CartItemsDocument, options);
      }
export function useCartItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartItemsQuery, CartItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartItemsQuery, CartItemsQueryVariables>(CartItemsDocument, options);
        }
export function useCartItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CartItemsQuery, CartItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartItemsQuery, CartItemsQueryVariables>(CartItemsDocument, options);
        }
export type CartItemsQueryHookResult = ReturnType<typeof useCartItemsQuery>;
export type CartItemsLazyQueryHookResult = ReturnType<typeof useCartItemsLazyQuery>;
export type CartItemsSuspenseQueryHookResult = ReturnType<typeof useCartItemsSuspenseQuery>;
export type CartItemsQueryResult = Apollo.QueryResult<CartItemsQuery, CartItemsQueryVariables>;
export const CartTotalDocument = gql`
    query CartTotal($cartId: String!) {
  cart(cart_id: $cartId) {
    id
    prices {
      applied_taxes {
        amount {
          currency
          value
        }
      }
      discounts {
        label
        amount {
          currency
          value
        }
      }
      grand_total {
        currency
        value
      }
      subtotal_excluding_tax {
        currency
        value
      }
      subtotal_including_tax {
        currency
        value
      }
      subtotal_with_discount_excluding_tax {
        currency
        value
      }
    }
  }
}
    `;

/**
 * __useCartTotalQuery__
 *
 * To run a query within a React component, call `useCartTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartTotalQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useCartTotalQuery(baseOptions: Apollo.QueryHookOptions<CartTotalQuery, CartTotalQueryVariables> & ({ variables: CartTotalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartTotalQuery, CartTotalQueryVariables>(CartTotalDocument, options);
      }
export function useCartTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartTotalQuery, CartTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartTotalQuery, CartTotalQueryVariables>(CartTotalDocument, options);
        }
export function useCartTotalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CartTotalQuery, CartTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartTotalQuery, CartTotalQueryVariables>(CartTotalDocument, options);
        }
export type CartTotalQueryHookResult = ReturnType<typeof useCartTotalQuery>;
export type CartTotalLazyQueryHookResult = ReturnType<typeof useCartTotalLazyQuery>;
export type CartTotalSuspenseQueryHookResult = ReturnType<typeof useCartTotalSuspenseQuery>;
export type CartTotalQueryResult = Apollo.QueryResult<CartTotalQuery, CartTotalQueryVariables>;
export const CartShippingAddressDocument = gql`
    query CartShippingAddress($cartId: String!) {
  cart(cart_id: $cartId) {
    id
    shipping_addresses {
      lastname
      postcode
      firstname
      customer_notes
      country {
        code
        label
      }
      city
      region {
        code
        label
      }
      district
      district_id
      ward
      ward_id
      street
      telephone
    }
    email
  }
}
    `;

/**
 * __useCartShippingAddressQuery__
 *
 * To run a query within a React component, call `useCartShippingAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartShippingAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartShippingAddressQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useCartShippingAddressQuery(baseOptions: Apollo.QueryHookOptions<CartShippingAddressQuery, CartShippingAddressQueryVariables> & ({ variables: CartShippingAddressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartShippingAddressQuery, CartShippingAddressQueryVariables>(CartShippingAddressDocument, options);
      }
export function useCartShippingAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartShippingAddressQuery, CartShippingAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartShippingAddressQuery, CartShippingAddressQueryVariables>(CartShippingAddressDocument, options);
        }
export function useCartShippingAddressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CartShippingAddressQuery, CartShippingAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartShippingAddressQuery, CartShippingAddressQueryVariables>(CartShippingAddressDocument, options);
        }
export type CartShippingAddressQueryHookResult = ReturnType<typeof useCartShippingAddressQuery>;
export type CartShippingAddressLazyQueryHookResult = ReturnType<typeof useCartShippingAddressLazyQuery>;
export type CartShippingAddressSuspenseQueryHookResult = ReturnType<typeof useCartShippingAddressSuspenseQuery>;
export type CartShippingAddressQueryResult = Apollo.QueryResult<CartShippingAddressQuery, CartShippingAddressQueryVariables>;
export const CustomerCartDocument = gql`
    query CustomerCart {
  customerCart {
    id
  }
}
    `;

/**
 * __useCustomerCartQuery__
 *
 * To run a query within a React component, call `useCustomerCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerCartQuery(baseOptions?: Apollo.QueryHookOptions<CustomerCartQuery, CustomerCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerCartQuery, CustomerCartQueryVariables>(CustomerCartDocument, options);
      }
export function useCustomerCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerCartQuery, CustomerCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerCartQuery, CustomerCartQueryVariables>(CustomerCartDocument, options);
        }
export function useCustomerCartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerCartQuery, CustomerCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerCartQuery, CustomerCartQueryVariables>(CustomerCartDocument, options);
        }
export type CustomerCartQueryHookResult = ReturnType<typeof useCustomerCartQuery>;
export type CustomerCartLazyQueryHookResult = ReturnType<typeof useCustomerCartLazyQuery>;
export type CustomerCartSuspenseQueryHookResult = ReturnType<typeof useCustomerCartSuspenseQuery>;
export type CustomerCartQueryResult = Apollo.QueryResult<CustomerCartQuery, CustomerCartQueryVariables>;
export const SetPaymentMethodOnCartDocument = gql`
    mutation SetPaymentMethodOnCart($input: SetPaymentMethodOnCartInput) {
  setPaymentMethodOnCart(input: $input) {
    cart {
      id
      selected_payment_method {
        code
        purchase_order_number
        title
      }
    }
  }
}
    `;
export type SetPaymentMethodOnCartMutationFn = Apollo.MutationFunction<SetPaymentMethodOnCartMutation, SetPaymentMethodOnCartMutationVariables>;

/**
 * __useSetPaymentMethodOnCartMutation__
 *
 * To run a mutation, you first call `useSetPaymentMethodOnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPaymentMethodOnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPaymentMethodOnCartMutation, { data, loading, error }] = useSetPaymentMethodOnCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPaymentMethodOnCartMutation(baseOptions?: Apollo.MutationHookOptions<SetPaymentMethodOnCartMutation, SetPaymentMethodOnCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPaymentMethodOnCartMutation, SetPaymentMethodOnCartMutationVariables>(SetPaymentMethodOnCartDocument, options);
      }
export type SetPaymentMethodOnCartMutationHookResult = ReturnType<typeof useSetPaymentMethodOnCartMutation>;
export type SetPaymentMethodOnCartMutationResult = Apollo.MutationResult<SetPaymentMethodOnCartMutation>;
export type SetPaymentMethodOnCartMutationOptions = Apollo.BaseMutationOptions<SetPaymentMethodOnCartMutation, SetPaymentMethodOnCartMutationVariables>;
export const SetShippingMethodsOnCartDocument = gql`
    mutation SetShippingMethodsOnCart($input: SetShippingMethodsOnCartInput) {
  setShippingMethodsOnCart(input: $input) {
    cart {
      id
      shipping_addresses {
        selected_shipping_method {
          amount {
            currency
            value
          }
          method_title
          method_code
          carrier_code
          carrier_title
        }
      }
    }
  }
}
    `;
export type SetShippingMethodsOnCartMutationFn = Apollo.MutationFunction<SetShippingMethodsOnCartMutation, SetShippingMethodsOnCartMutationVariables>;

/**
 * __useSetShippingMethodsOnCartMutation__
 *
 * To run a mutation, you first call `useSetShippingMethodsOnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShippingMethodsOnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShippingMethodsOnCartMutation, { data, loading, error }] = useSetShippingMethodsOnCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetShippingMethodsOnCartMutation(baseOptions?: Apollo.MutationHookOptions<SetShippingMethodsOnCartMutation, SetShippingMethodsOnCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetShippingMethodsOnCartMutation, SetShippingMethodsOnCartMutationVariables>(SetShippingMethodsOnCartDocument, options);
      }
export type SetShippingMethodsOnCartMutationHookResult = ReturnType<typeof useSetShippingMethodsOnCartMutation>;
export type SetShippingMethodsOnCartMutationResult = Apollo.MutationResult<SetShippingMethodsOnCartMutation>;
export type SetShippingMethodsOnCartMutationOptions = Apollo.BaseMutationOptions<SetShippingMethodsOnCartMutation, SetShippingMethodsOnCartMutationVariables>;
export const SetGuestEmailOnCartDocument = gql`
    mutation SetGuestEmailOnCart($input: SetGuestEmailOnCartInput) {
  setGuestEmailOnCart(input: $input) {
    cart {
      id
      email
    }
  }
}
    `;
export type SetGuestEmailOnCartMutationFn = Apollo.MutationFunction<SetGuestEmailOnCartMutation, SetGuestEmailOnCartMutationVariables>;

/**
 * __useSetGuestEmailOnCartMutation__
 *
 * To run a mutation, you first call `useSetGuestEmailOnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGuestEmailOnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGuestEmailOnCartMutation, { data, loading, error }] = useSetGuestEmailOnCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetGuestEmailOnCartMutation(baseOptions?: Apollo.MutationHookOptions<SetGuestEmailOnCartMutation, SetGuestEmailOnCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetGuestEmailOnCartMutation, SetGuestEmailOnCartMutationVariables>(SetGuestEmailOnCartDocument, options);
      }
export type SetGuestEmailOnCartMutationHookResult = ReturnType<typeof useSetGuestEmailOnCartMutation>;
export type SetGuestEmailOnCartMutationResult = Apollo.MutationResult<SetGuestEmailOnCartMutation>;
export type SetGuestEmailOnCartMutationOptions = Apollo.BaseMutationOptions<SetGuestEmailOnCartMutation, SetGuestEmailOnCartMutationVariables>;
export const PlaceOrderDocument = gql`
    mutation PlaceOrder($input: PlaceOrderInput) {
  placeOrder(input: $input) {
    order {
      order_id
      order_number
    }
  }
}
    `;
export type PlaceOrderMutationFn = Apollo.MutationFunction<PlaceOrderMutation, PlaceOrderMutationVariables>;

/**
 * __usePlaceOrderMutation__
 *
 * To run a mutation, you first call `usePlaceOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeOrderMutation, { data, loading, error }] = usePlaceOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlaceOrderMutation(baseOptions?: Apollo.MutationHookOptions<PlaceOrderMutation, PlaceOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlaceOrderMutation, PlaceOrderMutationVariables>(PlaceOrderDocument, options);
      }
export type PlaceOrderMutationHookResult = ReturnType<typeof usePlaceOrderMutation>;
export type PlaceOrderMutationResult = Apollo.MutationResult<PlaceOrderMutation>;
export type PlaceOrderMutationOptions = Apollo.BaseMutationOptions<PlaceOrderMutation, PlaceOrderMutationVariables>;
export const SetShippingAddressesOnCartDocument = gql`
    mutation SetShippingAddressesOnCart($input: SetShippingAddressesOnCartInput) {
  setShippingAddressesOnCart(input: $input) {
    cart {
      id
    }
  }
}
    `;
export type SetShippingAddressesOnCartMutationFn = Apollo.MutationFunction<SetShippingAddressesOnCartMutation, SetShippingAddressesOnCartMutationVariables>;

/**
 * __useSetShippingAddressesOnCartMutation__
 *
 * To run a mutation, you first call `useSetShippingAddressesOnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShippingAddressesOnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShippingAddressesOnCartMutation, { data, loading, error }] = useSetShippingAddressesOnCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetShippingAddressesOnCartMutation(baseOptions?: Apollo.MutationHookOptions<SetShippingAddressesOnCartMutation, SetShippingAddressesOnCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetShippingAddressesOnCartMutation, SetShippingAddressesOnCartMutationVariables>(SetShippingAddressesOnCartDocument, options);
      }
export type SetShippingAddressesOnCartMutationHookResult = ReturnType<typeof useSetShippingAddressesOnCartMutation>;
export type SetShippingAddressesOnCartMutationResult = Apollo.MutationResult<SetShippingAddressesOnCartMutation>;
export type SetShippingAddressesOnCartMutationOptions = Apollo.BaseMutationOptions<SetShippingAddressesOnCartMutation, SetShippingAddressesOnCartMutationVariables>;
export const SetBillingAddressesOnCartDocument = gql`
    mutation SetBillingAddressesOnCart($input: SetBillingAddressOnCartInput) {
  setBillingAddressOnCart(input: $input) {
    cart {
      id
    }
  }
}
    `;
export type SetBillingAddressesOnCartMutationFn = Apollo.MutationFunction<SetBillingAddressesOnCartMutation, SetBillingAddressesOnCartMutationVariables>;

/**
 * __useSetBillingAddressesOnCartMutation__
 *
 * To run a mutation, you first call `useSetBillingAddressesOnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBillingAddressesOnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBillingAddressesOnCartMutation, { data, loading, error }] = useSetBillingAddressesOnCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetBillingAddressesOnCartMutation(baseOptions?: Apollo.MutationHookOptions<SetBillingAddressesOnCartMutation, SetBillingAddressesOnCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetBillingAddressesOnCartMutation, SetBillingAddressesOnCartMutationVariables>(SetBillingAddressesOnCartDocument, options);
      }
export type SetBillingAddressesOnCartMutationHookResult = ReturnType<typeof useSetBillingAddressesOnCartMutation>;
export type SetBillingAddressesOnCartMutationResult = Apollo.MutationResult<SetBillingAddressesOnCartMutation>;
export type SetBillingAddressesOnCartMutationOptions = Apollo.BaseMutationOptions<SetBillingAddressesOnCartMutation, SetBillingAddressesOnCartMutationVariables>;
export const AvailableCouponsDocument = gql`
    query AvailableCoupons {
  availableCoupons {
    code
    description
    from_date
    is_active
    name
    to_date
  }
}
    `;

/**
 * __useAvailableCouponsQuery__
 *
 * To run a query within a React component, call `useAvailableCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableCouponsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableCouponsQuery(baseOptions?: Apollo.QueryHookOptions<AvailableCouponsQuery, AvailableCouponsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableCouponsQuery, AvailableCouponsQueryVariables>(AvailableCouponsDocument, options);
      }
export function useAvailableCouponsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableCouponsQuery, AvailableCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableCouponsQuery, AvailableCouponsQueryVariables>(AvailableCouponsDocument, options);
        }
export function useAvailableCouponsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailableCouponsQuery, AvailableCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableCouponsQuery, AvailableCouponsQueryVariables>(AvailableCouponsDocument, options);
        }
export type AvailableCouponsQueryHookResult = ReturnType<typeof useAvailableCouponsQuery>;
export type AvailableCouponsLazyQueryHookResult = ReturnType<typeof useAvailableCouponsLazyQuery>;
export type AvailableCouponsSuspenseQueryHookResult = ReturnType<typeof useAvailableCouponsSuspenseQuery>;
export type AvailableCouponsQueryResult = Apollo.QueryResult<AvailableCouponsQuery, AvailableCouponsQueryVariables>;
export const GetDiscountKicoinsDocument = gql`
    query GetDiscountKicoins($cartId: String!) {
  cart(cart_id: $cartId) {
    discount_kicoins {
      title
      value
    }
    id
  }
}
    `;

/**
 * __useGetDiscountKicoinsQuery__
 *
 * To run a query within a React component, call `useGetDiscountKicoinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountKicoinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountKicoinsQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useGetDiscountKicoinsQuery(baseOptions: Apollo.QueryHookOptions<GetDiscountKicoinsQuery, GetDiscountKicoinsQueryVariables> & ({ variables: GetDiscountKicoinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscountKicoinsQuery, GetDiscountKicoinsQueryVariables>(GetDiscountKicoinsDocument, options);
      }
export function useGetDiscountKicoinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountKicoinsQuery, GetDiscountKicoinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscountKicoinsQuery, GetDiscountKicoinsQueryVariables>(GetDiscountKicoinsDocument, options);
        }
export function useGetDiscountKicoinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDiscountKicoinsQuery, GetDiscountKicoinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDiscountKicoinsQuery, GetDiscountKicoinsQueryVariables>(GetDiscountKicoinsDocument, options);
        }
export type GetDiscountKicoinsQueryHookResult = ReturnType<typeof useGetDiscountKicoinsQuery>;
export type GetDiscountKicoinsLazyQueryHookResult = ReturnType<typeof useGetDiscountKicoinsLazyQuery>;
export type GetDiscountKicoinsSuspenseQueryHookResult = ReturnType<typeof useGetDiscountKicoinsSuspenseQuery>;
export type GetDiscountKicoinsQueryResult = Apollo.QueryResult<GetDiscountKicoinsQuery, GetDiscountKicoinsQueryVariables>;
export const ApplyKicoinsToCartDocument = gql`
    mutation ApplyKicoinsToCart($input: ApplyKicoinsInput) {
  applyKicoins(input: $input) {
    cart {
      id
    }
  }
}
    `;
export type ApplyKicoinsToCartMutationFn = Apollo.MutationFunction<ApplyKicoinsToCartMutation, ApplyKicoinsToCartMutationVariables>;

/**
 * __useApplyKicoinsToCartMutation__
 *
 * To run a mutation, you first call `useApplyKicoinsToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyKicoinsToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyKicoinsToCartMutation, { data, loading, error }] = useApplyKicoinsToCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyKicoinsToCartMutation(baseOptions?: Apollo.MutationHookOptions<ApplyKicoinsToCartMutation, ApplyKicoinsToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyKicoinsToCartMutation, ApplyKicoinsToCartMutationVariables>(ApplyKicoinsToCartDocument, options);
      }
export type ApplyKicoinsToCartMutationHookResult = ReturnType<typeof useApplyKicoinsToCartMutation>;
export type ApplyKicoinsToCartMutationResult = Apollo.MutationResult<ApplyKicoinsToCartMutation>;
export type ApplyKicoinsToCartMutationOptions = Apollo.BaseMutationOptions<ApplyKicoinsToCartMutation, ApplyKicoinsToCartMutationVariables>;
export const RemoveKicoinsFromCartDocument = gql`
    mutation RemoveKicoinsFromCart($input: RemoveKicoinsInput) {
  removeKicoins(input: $input) {
    cart {
      id
      discount_kicoins {
        title
        value
      }
    }
  }
}
    `;
export type RemoveKicoinsFromCartMutationFn = Apollo.MutationFunction<RemoveKicoinsFromCartMutation, RemoveKicoinsFromCartMutationVariables>;

/**
 * __useRemoveKicoinsFromCartMutation__
 *
 * To run a mutation, you first call `useRemoveKicoinsFromCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveKicoinsFromCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeKicoinsFromCartMutation, { data, loading, error }] = useRemoveKicoinsFromCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveKicoinsFromCartMutation(baseOptions?: Apollo.MutationHookOptions<RemoveKicoinsFromCartMutation, RemoveKicoinsFromCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveKicoinsFromCartMutation, RemoveKicoinsFromCartMutationVariables>(RemoveKicoinsFromCartDocument, options);
      }
export type RemoveKicoinsFromCartMutationHookResult = ReturnType<typeof useRemoveKicoinsFromCartMutation>;
export type RemoveKicoinsFromCartMutationResult = Apollo.MutationResult<RemoveKicoinsFromCartMutation>;
export type RemoveKicoinsFromCartMutationOptions = Apollo.BaseMutationOptions<RemoveKicoinsFromCartMutation, RemoveKicoinsFromCartMutationVariables>;
export const CustomerKicoinDocument = gql`
    query CustomerKicoin {
  customerKicoin {
    available
    balance
  }
}
    `;

/**
 * __useCustomerKicoinQuery__
 *
 * To run a query within a React component, call `useCustomerKicoinQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerKicoinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerKicoinQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerKicoinQuery(baseOptions?: Apollo.QueryHookOptions<CustomerKicoinQuery, CustomerKicoinQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerKicoinQuery, CustomerKicoinQueryVariables>(CustomerKicoinDocument, options);
      }
export function useCustomerKicoinLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerKicoinQuery, CustomerKicoinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerKicoinQuery, CustomerKicoinQueryVariables>(CustomerKicoinDocument, options);
        }
export function useCustomerKicoinSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerKicoinQuery, CustomerKicoinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerKicoinQuery, CustomerKicoinQueryVariables>(CustomerKicoinDocument, options);
        }
export type CustomerKicoinQueryHookResult = ReturnType<typeof useCustomerKicoinQuery>;
export type CustomerKicoinLazyQueryHookResult = ReturnType<typeof useCustomerKicoinLazyQuery>;
export type CustomerKicoinSuspenseQueryHookResult = ReturnType<typeof useCustomerKicoinSuspenseQuery>;
export type CustomerKicoinQueryResult = Apollo.QueryResult<CustomerKicoinQuery, CustomerKicoinQueryVariables>;
export const ApplyCouponToCartDocument = gql`
    mutation ApplyCouponToCart($input: ApplyCouponToCartInput) {
  applyCouponToCart(input: $input) {
    cart {
      id
      applied_coupons {
        code
      }
    }
  }
}
    `;
export type ApplyCouponToCartMutationFn = Apollo.MutationFunction<ApplyCouponToCartMutation, ApplyCouponToCartMutationVariables>;

/**
 * __useApplyCouponToCartMutation__
 *
 * To run a mutation, you first call `useApplyCouponToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCouponToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCouponToCartMutation, { data, loading, error }] = useApplyCouponToCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyCouponToCartMutation(baseOptions?: Apollo.MutationHookOptions<ApplyCouponToCartMutation, ApplyCouponToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyCouponToCartMutation, ApplyCouponToCartMutationVariables>(ApplyCouponToCartDocument, options);
      }
export type ApplyCouponToCartMutationHookResult = ReturnType<typeof useApplyCouponToCartMutation>;
export type ApplyCouponToCartMutationResult = Apollo.MutationResult<ApplyCouponToCartMutation>;
export type ApplyCouponToCartMutationOptions = Apollo.BaseMutationOptions<ApplyCouponToCartMutation, ApplyCouponToCartMutationVariables>;
export const RemoveCouponFromCartDocument = gql`
    mutation RemoveCouponFromCart($input: RemoveCouponFromCartInput) {
  removeCouponFromCart(input: $input) {
    cart {
      id
      applied_coupons {
        code
      }
    }
  }
}
    `;
export type RemoveCouponFromCartMutationFn = Apollo.MutationFunction<RemoveCouponFromCartMutation, RemoveCouponFromCartMutationVariables>;

/**
 * __useRemoveCouponFromCartMutation__
 *
 * To run a mutation, you first call `useRemoveCouponFromCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCouponFromCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCouponFromCartMutation, { data, loading, error }] = useRemoveCouponFromCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCouponFromCartMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCouponFromCartMutation, RemoveCouponFromCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCouponFromCartMutation, RemoveCouponFromCartMutationVariables>(RemoveCouponFromCartDocument, options);
      }
export type RemoveCouponFromCartMutationHookResult = ReturnType<typeof useRemoveCouponFromCartMutation>;
export type RemoveCouponFromCartMutationResult = Apollo.MutationResult<RemoveCouponFromCartMutation>;
export type RemoveCouponFromCartMutationOptions = Apollo.BaseMutationOptions<RemoveCouponFromCartMutation, RemoveCouponFromCartMutationVariables>;
export const GetAppliedCouponsDocument = gql`
    query GetAppliedCoupons($cartId: String!) {
  cart(cart_id: $cartId) {
    applied_coupons {
      code
    }
  }
}
    `;

/**
 * __useGetAppliedCouponsQuery__
 *
 * To run a query within a React component, call `useGetAppliedCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppliedCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppliedCouponsQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useGetAppliedCouponsQuery(baseOptions: Apollo.QueryHookOptions<GetAppliedCouponsQuery, GetAppliedCouponsQueryVariables> & ({ variables: GetAppliedCouponsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppliedCouponsQuery, GetAppliedCouponsQueryVariables>(GetAppliedCouponsDocument, options);
      }
export function useGetAppliedCouponsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppliedCouponsQuery, GetAppliedCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppliedCouponsQuery, GetAppliedCouponsQueryVariables>(GetAppliedCouponsDocument, options);
        }
export function useGetAppliedCouponsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppliedCouponsQuery, GetAppliedCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppliedCouponsQuery, GetAppliedCouponsQueryVariables>(GetAppliedCouponsDocument, options);
        }
export type GetAppliedCouponsQueryHookResult = ReturnType<typeof useGetAppliedCouponsQuery>;
export type GetAppliedCouponsLazyQueryHookResult = ReturnType<typeof useGetAppliedCouponsLazyQuery>;
export type GetAppliedCouponsSuspenseQueryHookResult = ReturnType<typeof useGetAppliedCouponsSuspenseQuery>;
export type GetAppliedCouponsQueryResult = Apollo.QueryResult<GetAppliedCouponsQuery, GetAppliedCouponsQueryVariables>;
export const CartItemsStatusDocument = gql`
    query CartItemsStatus($cartId: String!) {
  cartItemsStatus(cart_id: $cartId) {
    sku
    stock_status {
      code
      message
      current_available
    }
  }
}
    `;

/**
 * __useCartItemsStatusQuery__
 *
 * To run a query within a React component, call `useCartItemsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartItemsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartItemsStatusQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useCartItemsStatusQuery(baseOptions: Apollo.QueryHookOptions<CartItemsStatusQuery, CartItemsStatusQueryVariables> & ({ variables: CartItemsStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartItemsStatusQuery, CartItemsStatusQueryVariables>(CartItemsStatusDocument, options);
      }
export function useCartItemsStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartItemsStatusQuery, CartItemsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartItemsStatusQuery, CartItemsStatusQueryVariables>(CartItemsStatusDocument, options);
        }
export function useCartItemsStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CartItemsStatusQuery, CartItemsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartItemsStatusQuery, CartItemsStatusQueryVariables>(CartItemsStatusDocument, options);
        }
export type CartItemsStatusQueryHookResult = ReturnType<typeof useCartItemsStatusQuery>;
export type CartItemsStatusLazyQueryHookResult = ReturnType<typeof useCartItemsStatusLazyQuery>;
export type CartItemsStatusSuspenseQueryHookResult = ReturnType<typeof useCartItemsStatusSuspenseQuery>;
export type CartItemsStatusQueryResult = Apollo.QueryResult<CartItemsStatusQuery, CartItemsStatusQueryVariables>;